import React from 'react';
import PropTypes from 'prop-types';

import './toggle.scss';

function Toggle({is_on, onChange, is_disabled = false}) {
    return (
        <div className="toggle">
            <label>
                <input
                    type="checkbox"
                    disabled={is_disabled}
                    checked={is_on}
                    onChange={onChange}/>
                <span className="lever"/>
            </label>
        </div>
    );
}

Toggle.propTypes = {
    is_on: PropTypes.bool.isRequired,
    is_disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
}

export default Toggle;
